import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export default function MaskLines({ lines, className, delay = 0, testId }) {
  return (
    <motion.h2
      className={className}
      data-testid={testId}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
    >
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
            transition={{ duration: 0.8, delay: delay + i * 0.09, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.h2>
  );
}
